import { GtmEvents } from '@/gtm/gtm-events';

export class CartTotalWidgetGtmEvents extends GtmEvents {
  constructor() {
    super('СобытияВКорзине');
  }

  interaction() {
    return this.gtmEvent({
      eventAction: 'КРЗ_Виджет_Взаимодействие',
    });
  }

  toggleExpandedState(isActive) {
    if (isActive) {
      return this.gtmEvent({
        eventAction: 'КРЗ_Виджет_Показать',
      });
    }
    return this.gtmEvent({
      eventAction: 'КРЗ_Виджет_Скрыть',
    });
  }

  clickSubmit() {
    return this.gtmEvent({
      eventAction: 'КРЗ_Виджет_Оформить',
    });
  }
}

export const cartTotalWidgetGtmEvents = new CartTotalWidgetGtmEvents();
